export function removeHtmlTags(string: string | null) {
  if (!string) {
    return ''
  } else {
    return string.replace(/(<([^>]+)>)/gi, '')
  }
}
